export const PALLET_SCAN_MATCH = {
	MATCHED: "matched",
	UNMATCHED: "unmatched",
	AMBIGUOUS: "ambiguous",
};

// A relabeled pallet answers to two labels: the current sscc and the one it
// arrived with (sscc_original). The current label always wins (OL-1956)
export const matchPalletByScannedSscc = (pallets, sscc) => {
	const current = findPalletByCurrentSscc(pallets, sscc);
	if (current) {
		return { status: PALLET_SCAN_MATCH.MATCHED, pallet: current };
	}
	return matchPalletByOriginalSscc(pallets, sscc);
};

export const findPalletByCurrentSscc = (pallets, sscc) => pallets.find((pallet) => pallet.sscc === sscc);

export const matchPalletByOriginalSscc = (pallets, sscc) => {
	const relabeled = pallets.filter((pallet) => pallet.sscc_original === sscc);
	if (relabeled.length === 1) {
		return { status: PALLET_SCAN_MATCH.MATCHED, pallet: relabeled[0] };
	}
	return {
		status: relabeled.length === 0 ? PALLET_SCAN_MATCH.UNMATCHED : PALLET_SCAN_MATCH.AMBIGUOUS,
	};
};
